
import { getPhoneTopStyle } from '@/composables/fxwallet'
import { computed, defineComponent, watch } from 'vue'

export default defineComponent({
  props: {
    msg: {
      type: String,
      required: true
    },

    show: {
      type: Boolean,
      required: true
    }
  },

  emits: ['update:msg'],

  setup (props, { emit }) {
    const { padTop } = getPhoneTopStyle()

    const style = computed(() => ({
      top: padTop.value + 8 + 'px'
    }))

    function animationend () {
      emit('update:msg', false)
    }

    watch(() => props.msg, val => {
      console.log(val)
      if (val) {
        console.log(val)
        // emit('update:msg', true)
      }
    })

    return {
      style,
      animationend
    }
  }
})
